<script setup lang="ts">
import Search from '~/components/Search.vue'
import Modal from '~/components/Common/Modal/Modal.vue';

defineProps<{
	show: boolean
	showTypeTag?: boolean
}>()

const emits = defineEmits(['close'])

</script>

<template>

	<Modal
		:show="show"
		title="Search"
		class="max-h-fit"
		boxClass="w-full sm:max-w-xl"
		@close="emits('close')">
		<p>Discover health <strong>advice</strong>, <strong>discussions</strong>, <strong>products</strong> and more from people just like you</p>
		<Search
			:domains="['products', 'posts', 'articles', 'users']"
			class="flex text-center items-center justify-center"
			boxClass="w-full sm:max-w-xl"
			placeholder="Search Health Nutrition"
			closeOnSelect
			:showTypeTag="showTypeTag"
			@close="emits('close')"
		/>
	</Modal>

</template>
